<div
  class="behavior-card-wrapper"
  *ngIf="caseDetail.caseBehaviors && caseDetail.caseBehaviors.length > 0">
  <div *ngFor="let behavior of caseDetail?.caseBehaviors" class="with-chart">
    <div class="behavior-card">
      <div
        (click)="toggleBehaviorExpand(behavior)"
        (keydown.enter)="toggleBehaviorExpand(behavior)"
        tabindex="0"
        class="card-header"
        [ngClass]="
          behavior.draft
            ? 'card-header-draft'
            : behavior.statusId === 2
              ? ''
              : 'card-header-complete'
        ">
        <div class="header-left">
          <h3
            class="title"
            [ngClass]="behavior.draft ? 'orange-text' : 'green-text'">
            {{ behavior.behaviorCategoryName }}
          </h3>
          <p class="desc">
            {{ getCaseBehaviourSubTypes(behavior).join(', ') }}
          </p>
        </div>
        <div class="header-right">
          <span *ngIf="!behavior.draft">
            <span>
              {{ behavior.statusId === 1 ? 'Active' : 'Deactivated' }}
              <nz-switch
                [ngModel]="behavior.statusId === 1"
                (ngModelChange)="onActiveInActiveBehavior(behavior, $event)" />
            </span>
            <button
              *ngIf="behavior.isCorrectionNeeded"
              nz-button
              nzType="default"
              class="danger-btn"
              nz-tooltip
              nzTooltipTitle="Correction Needed"
              nzTooltipPlacement="bottom"
              (click)="openCorrectionNeededDrawer(behavior)">
              <svg-icon
                [title]="'Correction Needed'"
                src="/assets/icon/icon-info.svg"
                class="icon s-20"
                aria-label="Info"></svg-icon>
            </button>
          </span>
          <span *ngIf="behavior.draft">
            <!-- cta buttons -->
            <button
              *ngIf="behavior.isCorrectionNeeded"
              nz-button
              nzType="default"
              class="danger-btn"
              nz-tooltip
              nzTooltipTitle="Correction Needed"
              nzTooltipPlacement="bottom"
              (click)="openCorrectionNeededDrawer(behavior)">
              <svg-icon
                [title]="'Correction Needed'"
                src="/assets/icon/icon-info.svg"
                class="icon s-20"
                aria-label="Info"></svg-icon>
            </button>
            <!-- Hidden in favor of the "Edit Behavior (Wizard)" button below;
                 commented out (not deleted) so this can be restored easily. -->
            <!--
            <button
              *ngIf="allowManageBehavior"
              nz-button
              nzType="primary"
              class="draft-btn"
              (click)="editBehavior(behavior)">
              <svg-icon
                [title]="'Edit Behavior'"
                src="/assets/icon/icon-edit.svg"
                class="icon s-20"
                aria-label="Edit"></svg-icon>
            </button>
            -->
            <button
              *ngIf="allowManageBehavior"
              nz-button
              nzType="default"
              class="draft-btn wizard-edit-btn"
              nz-tooltip
              [nzTooltipTitle]="
                !isCaseQuestionnaireGatingClear
                  ? 'Complete the Required Case Questionnaires before Editing a Behavior'
                  : 'Edit Behavior'
              "
              [disabled]="!isCaseQuestionnaireGatingClear"
              (click)="openDefineBehaviorWizard(behavior)">
              <svg-icon
                [title]="'Edit Behavior'"
                src="/assets/icon/icon-edit.svg"
                class="icon s-20"
                aria-label="Edit"></svg-icon>
            </button>
            <button
              nz-button
              nzType="default"
              class="link-btn"
              nz-tooltip
              [nzTooltipTitle]="
                !isCaseQuestionnaireGatingClear
                  ? 'Complete the Required Case Questionnaires before Deleting a Behavior'
                  : null
              "
              [disabled]="!isCaseQuestionnaireGatingClear"
              (click)="deleteBehavior(behavior)">
              <svg-icon
                [title]="'Delete Behavior'"
                src="/assets/icon/icon-trash.svg"
                class="icon s-20"
                aria-label="Trash"></svg-icon>
            </button>
          </span>
        </div>
      </div>
      <div
        class="card-body"
        [ngClass]="{ overlay: behavior.statusId === 2 }"
        *ngIf="behavior.isExpanded">
        <div class="card-body-wrapper">
          <div class="card-content with-border">
            <nz-descriptions
              [nzColumn]="{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }">
              <nz-descriptions-item
                nzTitle="Operational Definition"
                [nzSpan]="2">
                <ng-container
                  *ngIf="behavior.operationalDefinition; else noDefinition">
                  <div class="definition-text">
                    {{ behavior.operationalDefinition | slice: 0 : 200 }}
                    <a
                      *ngIf="behavior.operationalDefinition.length > 200"
                      (click)="
                        showOperationalDefinitionModal(
                          behavior.operationalDefinition
                        )
                      "
                      (keydown.enter)="
                        showOperationalDefinitionModal(
                          behavior.operationalDefinition
                        )
                      "
                      tabindex="0"
                      class="show-more-link">
                      ...Show More
                    </a>
                  </div>
                </ng-container>
                <ng-template #noDefinition
                  >No operational definition has been provided</ng-template
                >
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Resource Added">
                <span [ngClass]="getDaysAgoColor(behavior.resourceAddedDate)">{{
                  behavior.resourceAddedDate
                    ? getDaysAgoText(behavior.resourceAddedDate)
                    : 'Not added yet'
                }}</span>
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Modified">
                <span [ngClass]="getDaysAgoColor(behavior.modifiedDate)">
                  {{
                    behavior.modifiedDate
                      ? getDaysAgoText(behavior.modifiedDate)
                      : 'Not modified'
                  }}
                </span>
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Data last entered" [nzSpan]="2">
                <span
                  [ngClass]="getDaysColorforDataEntry(behavior.dataEnteredDate)"
                  >{{
                    behavior.dataEnteredDate
                      ? getDaysAgoText(behavior.dataEnteredDate)
                      : 'Enter data for this behavior'
                  }}</span
                >
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Functions" [nzSpan]="2">
                <span *ngIf="behavior.behaviorFunction.length > 0">
                  {{ getFuncationsName(behavior.behaviorFunction) }}</span
                >
                <span *ngIf="behavior.behaviorFunction.length === 0"
                  >No functions identified</span
                >
              </nz-descriptions-item>
            </nz-descriptions>
          </div>
          <div class="card-content with-cards">
            <div
              class="sub-card"
              [class.sub-card-excluded]="!includedTiles[tileSection.Details]">
              <!-- Opens the template-driven wizard's view mode instead of the
                   legacy DefineBehaviorComponent; old binding kept commented
                   below for easy revert:
                   (click)="editBehavior(behavior, true)" -->
              <button
                [disabled]="!isTileEnabled(behavior, tileSection.Details)"
                [class.link-button-disabled]="
                  !isTileEnabled(behavior, tileSection.Details)
                "
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openDefineBehaviorWizard(behavior, true)">
                {{ behaviorDetails | reportLabel | async }}
              </button>
              <p
                class="desc"
                [ngClass]="{
                  'red-text': hasPendingHardStop(behavior),
                  'orange-text':
                    !hasPendingHardStop(behavior) &&
                    hasPendingRequired(behavior),
                  'green-text':
                    !hasPendingHardStop(behavior) &&
                    !hasPendingRequired(behavior),
                }">
                <ng-container
                  *ngIf="
                    hasPendingHardStop(behavior) || hasPendingRequired(behavior)
                  ">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  Complete {{ behaviorDetails | reportLabel | async }}
                </ng-container>
                <ng-container
                  *ngIf="
                    !hasPendingHardStop(behavior) &&
                    !hasPendingRequired(behavior)
                  ">
                  <svg-icon
                    src="/assets/icon/icon-check-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Check Circle Sm"></svg-icon>
                  {{ behaviorDetails | reportLabel | async }} completed
                </ng-container>
              </p>
            </div>
            <div
              class="sub-card"
              [class.sub-card-excluded]="
                !includedTiles[tileSection.Assessment]
              ">
              <button
                [disabled]="
                  !isTileEnabled(behavior, tileSection.Assessment) ||
                  (!allowManageAssessment && !isAssessmentCompleted(behavior))
                "
                [class.link-button-disabled]="
                  !isTileEnabled(behavior, tileSection.Assessment) ||
                  (!allowManageAssessment && !isAssessmentCompleted(behavior))
                "
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openAssessmentFbaDrawer(behavior)">
                {{ assessLabel | reportLabel | async }}
              </button>
              <p
                class="desc"
                [ngClass]="{
                  'red-text': hasPendingHardStop(behavior),
                  'orange-text':
                    !hasPendingHardStop(behavior) &&
                    (hasPendingRequired(behavior) ||
                      behavior.behaviorFunction.length === 0 ||
                      behavior.behaviorAssessmentGraph.length === 0),
                  'green-text':
                    !hasPendingHardStop(behavior) &&
                    !hasPendingRequired(behavior) &&
                    behavior.behaviorFunction.length > 0 &&
                    behavior.behaviorAssessmentGraph.length > 0,
                }">
                <ng-container
                  *ngIf="
                    hasPendingHardStop(behavior) || hasPendingRequired(behavior)
                  ">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  Complete {{ behaviorDetails | reportLabel | async }}
                  first
                </ng-container>
                <ng-container
                  *ngIf="
                    !hasPendingHardStop(behavior) &&
                    !hasPendingRequired(behavior) &&
                    behavior.behaviorFunction.length > 0 &&
                    behavior.behaviorAssessmentGraph.length > 0
                  ">
                  <svg-icon
                    src="/assets/icon/icon-check-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Check Circle Sm"></svg-icon>
                  {{ assessLabel | reportLabel | async }} completed
                </ng-container>
                <ng-container
                  *ngIf="
                    !hasPendingHardStop(behavior) &&
                    !hasPendingRequired(behavior) &&
                    (behavior.behaviorFunction.length === 0 ||
                      behavior.behaviorAssessmentGraph.length === 0)
                  ">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  {{ assessLabel | reportLabel | async }} needed
                </ng-container>
              </p>
            </div>
            <div
              class="sub-card"
              [class.sub-card-excluded]="!includedTiles[tileSection.Strategy]">
              <button
                [disabled]="!isTileEnabled(behavior, tileSection.Strategy)"
                [class.link-button-disabled]="
                  !isTileEnabled(behavior, tileSection.Strategy)
                "
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openManageBehaviorStrategiesDrawer(behavior)">
                Strategies
              </button>
              <p
                class="desc"
                [ngClass]="!behavior.appliedStrategyCount ? '' : 'green-text'">
                <svg-icon
                  [src]="
                    behavior.appliedStrategyCount &&
                    behavior.appliedStrategyCount > 0
                      ? '/assets/icon/icon-check-circle-sm.svg'
                      : '/assets/icon/icon-info-circle-sm.svg'
                  "
                  class="icon s-12"
                  aria-label="Strategy Status">
                </svg-icon>
                {{
                  behavior.appliedStrategyCount &&
                  behavior.appliedStrategyCount > 0
                    ? behavior.appliedStrategyCount === 1
                      ? '1 strategy has been added'
                      : behavior.appliedStrategyCount +
                        ' strategies have been added'
                    : 'No strategy has been added'
                }}
              </p>
            </div>
            <div
              class="sub-card"
              [class.sub-card-excluded]="!includedTiles[tileSection.Data]">
              <button
                [disabled]="!isTileEnabled(behavior, tileSection.Data)"
                [class.link-button-disabled]="
                  !isTileEnabled(behavior, tileSection.Data)
                "
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openDataDrawer(behavior)">
                Data
              </button>
              <p
                class="desc"
                [ngClass]="getDaysColorforDataEntry(behavior.dataEnteredDate)">
                <svg-icon
                  [src]="
                    behavior.dataEnteredDate
                      ? '/assets/icon/icon-check-circle-sm.svg'
                      : '/assets/icon/icon-info-circle-sm.svg'
                  "
                  aria-label="Icon"></svg-icon>
                <span>{{
                  behavior.dataEnteredDate
                    ? 'Data Last Entered: ' +
                      (behavior.dataEnteredDate | userDate: 'MM/dd/yyyy')
                    : 'Enter data for Behavior'
                }}</span>
              </p>
            </div>

            <!-- pass block class to display in full width -->
            <div
              class="sub-card block"
              *ngIf="
                (behavior.behaviorFunction.length === 0 ||
                  behavior.behaviorAssessmentGraph.length === 0 ||
                  behavior.appliedStrategyCount === 0 ||
                  hasPendingHardStop(behavior) ||
                  hasPendingRequired(behavior)) &&
                canResumeProcess(behavior)
              ">
              <p
                class="desc"
                [ngClass]="{
                  'red-text': !isResumeRequiredOnly(behavior),
                  'orange-text': isResumeRequiredOnly(behavior),
                }">
                <svg-icon
                  [src]="
                    isResumeRequiredOnly(behavior)
                      ? '/assets/icon/icon-info-circle-sm.svg'
                      : '/assets/icon/icon-warning-circle-sm.svg'
                  "
                  class="icon s-12"
                  aria-label="Icon">
                </svg-icon>
                <ng-container
                  *ngIf="
                    behavior.behaviorFunction.length === 0 ||
                    behavior.behaviorAssessmentGraph.length === 0 ||
                    behavior.appliedStrategyCount === 0 ||
                    hasPendingHardStop(behavior) ||
                    hasPendingRequired(behavior)
                  ">
                  <div class="green-text resume-button-container">
                    <span>
                      Please complete the
                      {{
                        getDynamicLabel(behavior) | reportLabel | async
                      }}</span
                    >

                    <button
                      nz-button
                      nzType="default"
                      (click)="
                        resumeProcess(getDynamicLabel(behavior), behavior)
                      ">
                      Resume
                    </button>
                  </div>
                </ng-container>
              </p>
            </div>
          </div>
        </div>

        <div class="card-body-wrapper">
          <app-screener-results-graph
            *ngIf="
              includedTiles[tileSection.Assessment] &&
              behavior.behaviorAssessmentGraph.length > 0 &&
              behavior.behaviorFunction.length > 0
            "
            [graphData]="behavior.behaviorAssessmentGraph"
            [chartId]="'list-chart_' + generateRandomId"
            (chartImage)="onChartImageGenerated($event, behavior)" />
          <div
            class="chart-container"
            *ngIf="
              !includedTiles[tileSection.Assessment] ||
              behavior.behaviorAssessmentGraph.length === 0 ||
              behavior.behaviorFunction.length === 0
            ">
            <!-- Chart -->
            <app-screener-results-graph
              [class.blurred]="showOverlay"
              [graphData]="[]"
              [chartId]="'list-chart_' + generateRandomId">
            </app-screener-results-graph>

            <!-- Overlay -->
            <div class="chart-overlay" *ngIf="showOverlay">
              <div class="overlay-content">
                <span class="lock" *ngIf="showLock"
                  ><svg-icon
                    src="/assets/icon/icon-lock.svg"
                    class="icon s-20"
                    aria-label="Lock"></svg-icon
                ></span>
                <span>
                  Please complete the
                  {{ getDynamicLabel(behavior) | reportLabel | async }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="caseDetail.caseBehaviors && caseDetail.caseBehaviors.length === 0">
    <app-no-data title="No Behavior" desc="No Behavior Defined"></app-no-data>
  </div>
  <app-confirm-dialog
    [isVisible]="isDeleteDialogOpen"
    title="Delete Behavior"
    message="Are you sure you want to delete the Behavior?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="handleDelete()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>

  <ng-template #drawerTitleTpl>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <ng-container
          *ngIf="
            getSectionHelpText(tileSection.Assessment) as screenerHelpText;
            else screenerTitleOnlyTpl
          ">
          <div class="drawer-title-row">
            <h3 class="ant-drawer-title">Behavior Screener</h3>
            <app-help-text [text]="screenerHelpText"></app-help-text>
          </div>
        </ng-container>
        <ng-template #screenerTitleOnlyTpl>
          <h3 class="ant-drawer-title">Behavior Screener</h3>
        </ng-template>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span> {{ caseDetail.student.firstName }}'s </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeFBADrawer()"
            (keydown.enter)="closeFBADrawer()">
            <a tabindex="0">Assessment FBA</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>

  <ng-template #drawerBehaviorTitleTpl>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <ng-container
          *ngIf="
            getSectionHelpText(tileSection.Details) as behaviorHelpText;
            else behaviorTitleOnlyTpl
          ">
          <div class="drawer-title-row">
            <h3 class="ant-drawer-title">Define Behavior</h3>
            <app-help-text [text]="behaviorHelpText"></app-help-text>
          </div>
        </ng-container>
        <ng-template #behaviorTitleOnlyTpl>
          <h3 class="ant-drawer-title">Define Behavior</h3>
        </ng-template>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span> {{ caseDetail.student.firstName }}'s </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeBehaviorDrawer()"
            (keydown.enter)="closeBehaviorDrawer()">
            <a tabindex="0">Define Behavior</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>

  <ng-template #drawerBehaviorWizardTitleTpl>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <ng-container
          *ngIf="
            getSectionHelpText(tileSection.Details) as behaviorWizardHelpText;
            else behaviorWizardTitleOnlyTpl
          ">
          <div class="drawer-title-row">
            <h3 class="ant-drawer-title">Define Behavior</h3>
            <app-help-text [text]="behaviorWizardHelpText"></app-help-text>
          </div>
        </ng-container>
        <ng-template #behaviorWizardTitleOnlyTpl>
          <h3 class="ant-drawer-title">Define Behavior</h3>
        </ng-template>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span> {{ caseDetail.student.firstName }}'s </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeDefineBehaviorWizard()"
            (keydown.enter)="closeDefineBehaviorWizard()">
            <a tabindex="0">Define Behavior</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>

  <ng-template #drawerTitleBehaviorStrategies>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <ng-container
          *ngIf="
            getSectionHelpText(tileSection.Strategy) as strategyHelpText;
            else strategyTitleOnlyTpl
          ">
          <div class="drawer-title-row">
            <h3 class="ant-drawer-title">Manage Behavior Strategies</h3>
            <app-help-text [text]="strategyHelpText"></app-help-text>
          </div>
        </ng-container>
        <ng-template #strategyTitleOnlyTpl>
          <h3 class="ant-drawer-title">Manage Behavior Strategies</h3>
        </ng-template>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span>
              <span> {{ caseDetail.student.firstName }}'s </span>
            </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeManageBehaviorStrategiesDrawer()"
            (keydown.enter)="closeManageBehaviorStrategiesDrawer()">
            <a tabindex="0">Strategies</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>
</div>

<nz-modal
  [(nzVisible)]="isDefinitionModalVisible"
  [nzTitle]="modalHeaderTemplate"
  (nzOnCancel)="handleModalClose()"
  nzWidth="600px">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Operational Definition</h3>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <p class="detail-list">{{ selectedDefinition }}</p>
  </ng-container>

  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="handleModalClose()">
      Close
    </button>
  </div>
</nz-modal>

<ng-template #correctionNeededTpl>
  <app-drawer-header
    [title]="(fidelityCheckLabel | reportLabel | async) ?? ''"
    [subtitle]="'Correction Needed'"
    breadcrumbText="{{ caseDetail.student.firstName }}'s"
    (drawerClose)="closeCorrectionNeededDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerTitleData>
  <app-drawer-header
    [title]="'Data'"
    subtitle="''"
    [breadcrumbText]="''"
    [helpText]="getSectionHelpText(tileSection.Data)"
    (drawerClose)="closeDataDrawer()">
  </app-drawer-header>
</ng-template>
